var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",class:[_vm.b(),_vm.className],style:(_vm.styleSizeName)},[(_vm.reload)?_c(_vm.id,{tag:"component",attrs:{"dataChart":_vm.dataChart},on:{"click":_vm.handleClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }